import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BusinessDetailsFormComponent } from './business-details-form.component';
import { UiComponentsModule } from '../ui-components.module';

@NgModule({
  imports: [CommonModule, FormsModule, ReactiveFormsModule, UiComponentsModule, BusinessDetailsFormComponent],
  exports: [BusinessDetailsFormComponent],
})
export class BusinessDetailsFormModule {}
